import { type LicensingMailboxInfo } from "owa-account-source-list-types";
import getAccountBySourceId from "../selectors/getAccountBySourceId";
import { accountRankTypeChecker } from "../store/schema/AccountSourceList";
import setCoprincipalAdditionalProps from "./setCoprincipalAdditionalProps";

export default function addEasidMailboxInfoAsLicensingMailboxInfo(sourceId: string, easidMailboxInfo: LicensingMailboxInfo): void {
    const accountSource = getAccountBySourceId(sourceId);
    
    if (accountRankTypeChecker.isCoprincipal(accountSource)) {
        setCoprincipalAdditionalProps(sourceId, {
            licensingMailboxInfo: easidMailboxInfo,
        });
    }
}
